const agentWebsocketActionsConstants = Object.freeze({
  NEW_CHAT: 'new_chat',
  CONTINUE_CHAT: 'continue_chat',
  CONFIRM: 'confirm',
  FILL_MISSING_INFO: 'fill_missing_info',
});


const agentWebsocketFlowConstants = Object.freeze({
  EXPENSE_SUBMISSION: 'expense-submission',
  MISSING_INFO: 'missing-info',
});


const backendWebsocketActionsConstants = Object.freeze({
  AUTH: 'auth',
  CARD_ACTIVATE: 'card_activate',
  CARD_CREATE: 'card_create',
  CARD_CREATE_ERROR: 'card_create_error',
  EXPENSE_FILL_MISSING_INFO: 'expense_fill_missing_info',
  EXPENSE_SUBMITTED: 'expense_submitted',
  VENDOR_CREATE_COMPLETED: 'vendor_create_completed',
  VENDOR_CREATE_ERROR: 'vendor_create_error',
});

const bankingWebsocketActionsConstants = Object.freeze({
  AUTH: 'auth',
  // enroll actions
  KEYLESS_ENROLL: 'keylessEnroll',
  KEYLESS_ENROLLMENT_SUCCESS: 'keylessEnrollmentSuccess',
  KEYLESS_ENROLLMENT_FAILURE: 'keylessEnrollmentFailure',
  KEYLESS_ENROLL_SMS_VERIFICATION_FAILURE: 'keylessEnrollSMSVerificationFailure',
  // authenticate actions
  KEYLESS_AUTHENTICATE: 'keylessAuthenticate',
  KEYLESS_AUTHENTICATE_SUCCESS: 'keylessChallengeAuthenticationSuccess',
  KEYLESS_AUTHENTICATE_FAILED: 'keylessChallengeAuthenticationFailed'
});

export {
  agentWebsocketActionsConstants,
  agentWebsocketFlowConstants,
  backendWebsocketActionsConstants,
  bankingWebsocketActionsConstants
};
